var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"c-recaptcha-wrapper"},[_c('div',{ref:"container"}),_vm._v(" "),(_vm.error)?_c(_setup.CError,{attrs:{"message":_vm.errorMsg}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }